import {
	ControllerRenderProps,
	FieldError,
	FieldErrorsImpl,
	FieldValues,
	Merge,
} from 'react-hook-form';
import React, { Fragment } from 'react';

interface InputProps {
	field: ControllerRenderProps<FieldValues, any>;
	label: string;
	errorMessage?: string | FieldError | Merge<FieldError, FieldErrorsImpl<any>>;
}
function Input({ field, label, errorMessage }: InputProps) {
	return (
		<Fragment>
			<label htmlFor={field.name}>{label}</label>
			<div className='card-input__body__input__wrapper'>
				<input
					data-test-id='card-input-input'
					id={field.name}
					{...field}
					className='card-input__body__input'
					type='text'
					autoComplete='on'
				/>
				<span data-test-id='card-input-error' className='input__error'>
					{errorMessage as string}
				</span>
			</div>
		</Fragment>
	);
}

export default Input;
